import type { MainPageBlock } from '@entities/MainPageConfig'

import BannerBlock from '@features/main-page-builder/ui/blocks/BannerBlock'
import BannerGalleryBlock from '@features/main-page-builder/ui/blocks/BannerGalleryBlock'
import CategoriesBlock from '@features/main-page-builder/ui/blocks/CategoriesBlock'
import ProductsBlock from '@features/main-page-builder/ui/blocks/ProductsBlock'
import TextMaterialsBlock from '@features/main-page-builder/ui/blocks/TextMaterialsBlock'

export interface BlockProps {
  block: MainPageBlock;
  payload: Record<string, unknown> | null;
  shopId: string;
}

export const blockComponents: Record<string, React.FC<BlockProps>> = {
  banner: BannerBlock,
  bannerGallery: BannerGalleryBlock,
  products: ProductsBlock,
  categories: CategoriesBlock,
  textMaterials: TextMaterialsBlock,
}

export type BlockType = keyof typeof blockComponents;